import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';

export const programId = '64b9b632c1be640794a7bba0';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },

    logLevel: 'error',
    useFingerprinting: true,
};
